import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { APP_CONTEXTS } from "app/model"
import { IForecastResultGroup } from "campaign/model"

export const MAP_INVENTORY_QUANTILE_STEPS = 10
export const MAP_INVENTORY_SCREENS_OPACITY = 1

export enum INVENTORY_MAP_VIEW_TYPES {
  GEO_TARGETS = "geo-targets",
  SCREENS = "screens",
  IMPRESSIONS = "impressions"
}

export interface IScreenData {
  centroid_longitude: number
  centroid_latitude: number
  screen_ids: string[]
  screen_count: number
  impressions: number
  spend: number
}

export interface IMapInventoryLegendData {
  mapImpressionsQuantiles: number[]
  mapMaxImpressionsValue: number
}

export interface IFormInventory extends IMapInventoryLegendData {
  isCreation: boolean
  isForecast: boolean
  tempCampaignId: number
  lastUpdate: Date
  campaignName: string | null
  isRefreshing: boolean
  hasRefreshError: boolean
  mapViewType: INVENTORY_MAP_VIEW_TYPES
  isMapVisible: boolean
  isMapLoading: boolean
  isMapLoaded: boolean
  isMapRefreshing: boolean
  contextType: APP_CONTEXTS
  totalGeoTargets: number
  totalScreens: number
  totalImpressions: number
  totalSpend: number
  cpmForecastTotalImpressions: number
  cpmForecastTotalScreens: number
  cpmForecastTotalSpend: number
  cpmForecastGroups: IForecastResultGroup[]
  screens: IScreenData[]
}

export interface IRefreshInventoryParams {
  campaignId?: number
  campaignName?: string
  ignoreWarnMessage?: boolean
}

export interface IInventoryMapButtonProps {
  viewType: INVENTORY_MAP_VIEW_TYPES
  count: number
  label: string
  icon: IconDefinition
  isActive: boolean
  isRefreshing: boolean
}
